import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { selectEntitiesByFilters } from "../../../shared/store/views/entityView";
import { addedByEduToolsFilters, basicToolsFilters, personalToolsFilters, schoolToolsFilters } from "../../../shared/utils/entitiesFiltersUtils";
import { mapToolsForDisplay } from "../../../shared/utils/toolDisplayUtils";
import { usePermission } from "../../../shared/hooks/usePermission";
import { openInNewTab } from "../../../shared/utils/utils";
import { deleteToolThunk } from "../../../shared/store/redux/tool-actions";
import Page from "../../../shared/components/ui/page/Page";
import pathRouts from "../../../shared/enums/pathRoute";
import iconsList from "../../../shared/components/ui/icons/iconsList";
import ToolsList from "../../../shared/components/features/toolsList/ToolsList";
import ToolsListWithAction from "../../../shared/components/features/toolsList/toolsListWithAction/ToolsListWithAction";
import sourceToolTypeEnum from "../../../shared/enums/sourceToolTypeEnum";
import toolLevelType from "../../../shared/enums/toolLevelType";
import targetGroupType from "../../../shared/enums/targetGroupType";
import toolActionsType from "../../../shared/enums/toolActionsType";
import classes from "./UsefulToolsPage.module.css";

const UsefulToolsPage = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { lang, texts } = useSelector(state => state.translate)
    const { general } = useSelector(state => state.uiData);
    const schoolId = useSelector(state => state.auth.userDetails?.defaultSchool?.id);
    const schoolFilters = useMemo(() => schoolToolsFilters(schoolId), [schoolId]);
    const basicTools = useSelector((state) => selectEntitiesByFilters(state, basicToolsFilters));
    const personalTools = useSelector((state) => selectEntitiesByFilters(state, personalToolsFilters));
    const addedByEduTools = useSelector((state) => selectEntitiesByFilters(state, addedByEduToolsFilters));
    const schoolTools = useSelector((state) => selectEntitiesByFilters(state, schoolFilters));
    const hasPermission = usePermission();
    const teacherPersonalTools = mapToolsForDisplay(personalTools, lang);

    const handleDelete = (tool) => {
        dispatch(deleteToolThunk(tool));
    };

    return (
        <Page title={texts.usefulTools} icon={iconsList.usefulTools} onBack={() => navigate(`/${pathRouts.HOME}`)} >
            <div className={classes.UsefulToolsPage}>
                <p className={classes.UsefulToolsTitle}>{texts.usefulTools}</p>
                <ToolsList
                    className={classes.MyToolsList} tools={mapToolsForDisplay(basicTools?.filter(tool => hasPermission(tool.visibleTo)), lang)}
                />
                <div className={classes.ToolsListsRow}>
                    <ToolsListWithAction
                        className={classes.PersonalToolsList}
                        text={texts.personalTools}
                        tools={teacherPersonalTools}
                        onDelete={handleDelete}
                        actionsType={toolActionsType.dots}
                        sourceTypeId={sourceToolTypeEnum.Teacher}
                        toolLevel={toolLevelType.Personal}
                        targetGroup={targetGroupType.Teacher}
                    />
                    <ToolsList
                        className={classes.educationToolsList}
                        text={texts.educationTools}
                        tools={mapToolsForDisplay(schoolTools?.filter(tool => hasPermission(tool.visibleTo)), lang)}
                    />
                </div>
                <ToolsList
                    className={`${classes.recommendedToolsList} ${classes.ToolsListMinistryOfEducation}`}
                    text={texts.recommendedToolsMinistryOfEducation}
                    tools={mapToolsForDisplay(addedByEduTools?.filter(tool => hasPermission(tool.visibleTo)), lang)}
                    link={general.usefulToolsLinkForTeacher}
                    textLink={texts.catalogTools}
                />
            </div>
            <p className={classes.CatalogToolsLink} onClick={() => { openInNewTab(general.usefulToolsLinkForTeacher) }}>{texts.catalogTools}</p>
        </Page>
    );
};

export default UsefulToolsPage; 